import Dialog from "./Dialog";
import useAuth from "../../hooks/useAuth";
import {useState} from "react";
import useAuthLoginFlow from "../../hooks/useAuthLoginFlow";
import useAppModernisation from "../../hooks/useAppModernisation";

const LoginAlertDialog = ({bodyText}) => {
  const { isLogged } = useAuth();
  const { isAppMode } = useAppModernisation();
  const [isOpen, setIsOpen] = useState(isAppMode && !isLogged);
  const { handleLoginClick } = useAuthLoginFlow();

  return (
    <Dialog
      bodyText={bodyText || "Please log in to view contents"}
      confirmFunction={handleLoginClick}
      heading="Log in"
      buttonText="Login"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    ></Dialog>
  );
};

export default LoginAlertDialog;